import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { API } from "src/util/api";
import { createComplaintFormError, createComplaintFormSuccess, deleteComplaintDocumentError, deleteComplaintDocumentSuccess, deleteComplaintError, deleteComplaintSuccess, getAllComplaintDropdownError, getAllComplaintDropdownSuccess, getComplaintDocumentError, getComplaintDocumentLoading, getComplaintDocumentSuccess, getComplaintDropdownError, getComplaintDropdownSuccess, getComplaintFormByIdError, getComplaintFormByIdSuccess, getComplaintListError, getComplaintListSuccess, getPrefixDropdownError, getPrefixDropdownSuccess } from "./actions";
import { ComplaintTypes } from "./actionTypes";
import { all } from "axios";

function* fetchComplaints(action: any) {
  try {
    const response: Promise<any> = yield call(API.getComplaintList, { ...action.lazyState });
    yield put(getComplaintListSuccess(response));
  } catch (error) {
    yield put(getComplaintListError(error));
  }
}

function* fetchComplaintById(action: any) {
  try {
    const response: Promise<any> = yield call(API.getComplaintById,action.payload);
    yield put(getComplaintFormByIdSuccess(response));
  } catch (error) {
    yield put(getComplaintFormByIdError(error));
  }
}

const fileToBase64 = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file); // gives base64 with data:<mime>;base64,
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = (error) => reject(error);
  });
};

// 2️⃣ Convert Base64 to Blob
const base64ToBlob = (base64: string): Blob => {
  const parts = base64.split(",");
  const mime = parts[0].match(/:(.*?);/)?.[1] || "";
  const binary = atob(parts[1]);
  const array = new Uint8Array(binary.length);

  for (let i = 0; i < binary.length; i++) {
    array[i] = binary.charCodeAt(i);
  }

  return new Blob([array], { type: mime });
};

function* uploadLargeProofDocuments(
  proofDocumentPayload: any[],
  proofDocumentsLarge: any[],
  complaintId?:any
) {
  if (!proofDocumentPayload?.length) return;
  debugger
  for (let i = 0; i < proofDocumentPayload.length; i++) {
    try {
      debugger
      // 1️⃣ Get presigned URL + proofId
      const { data } = yield call(API.createComplaintDocumentsApi, proofDocumentPayload[i],complaintId);

      if (data?.fileUploadUrl && data?.proofId) {
      const contentType = proofDocumentPayload[i].fileContentType;
      
        debugger
  //         const base64:string  = yield call(fileToBase64, proofDocumentsLarge[i]);
  // // convert base64 -> blob
  //         const blob:string = yield call(base64ToBlob, base64);
         const response: Response = yield call(fetch, data.fileUploadUrl, {
          method: "PUT",
          headers: {
            "Content-Type": contentType,
          },
          body: proofDocumentsLarge[i] as Blob,
        });


        // 3️⃣ Notify backend once upload succeeded
        if (response.ok) {
          yield call(API.createComplaintDocumentsLargeSuccessApi, data.proofId);
          console.log(`✅ File ${proofDocumentsLarge[i].fileName} uploaded & marked success`);
        } else {
          console.error(
            `❌ Upload failed for ${proofDocumentsLarge[i].fileName}`,
            response.statusText
          );
        }
      }
    } catch (err) {
      console.error("⚠️ Error in uploadLargeProofDocuments saga:", err);
    }
  }
}

const fileToPayload = (files:any,id:any)=>{
  debugger
  return files.map((file:any) => {
    return {
      id: 0,
      jobId: 0,
      proofName: file.name, // file name as proof name
      userId: JSON.parse(localStorage.getItem("authUser") || "")?.uid,
      file: "", // if you want Base64, convert file -> base64 here
      fileContentType: file.type,
      fileName: file.name,
      isDealerUpdate: true,
      documentDetail: {
        fileSize: file.size,
        mimeType: file.type,
        name: file.name,
      },
    };
  });
}
function* createComplaintFormAsync(action: any): Generator {
  try {
    let formpayload = {
       complaintName: action.payload.data.complaintName as string,
      jobPrefix: action.payload.data.jobPrefix as string,
      complaintPoints: action.payload.data.complaintPoints as string,
    }
        if(action.payload.id){
          const response: any = yield call(API.updateComplaint,formpayload,action.payload.id);
           if(action.payload.data.selectedFiles && action.payload.data.selectedFiles.length > 0 && response){
            let filesPayload  = fileToPayload(action.payload.data.selectedFiles.map((f: any) => f.file instanceof File ? f.file : null),response.data.id);
            const fileResponse : any = yield call(uploadLargeProofDocuments,filesPayload,action.payload.data.selectedFiles.map((f: any) => f.file instanceof File ? f.file : null),action.payload.id);

          }
          yield put(createComplaintFormSuccess("Complaint Updated Successfully"));

    }else{
          const response: any = yield call(API.createComplaint,formpayload);
          if(action.payload.data.selectedFiles && action.payload.data.selectedFiles.length > 0 && response){
            // const fileResponse : any = yield call(API.postComplaintFiles,response.data.id,action.payload.data.selectedFiles.map((f: any) => f.file instanceof File ? f.file : null))
            let filesPayload  = fileToPayload(action.payload.data.selectedFiles.map((f: any) => f.file instanceof File ? f.file : null),response.data.id);
             const fileResponse : any = yield call(uploadLargeProofDocuments,filesPayload,action.payload.data.selectedFiles.map((f: any) => f.file instanceof File ? f.file : null),response.data.id);

          }
          yield put(createComplaintFormSuccess("Complaint Created Successfully"));
    }
  } catch (error) {
    yield put(createComplaintFormError(error));
  }
}

function* deleteComplaintAsync(action: any) {
  try {
    const response: Promise<any> = yield call(API.deleteComplaintAPI,action.payload);
    yield put(deleteComplaintSuccess(response,action.payload.undo));
  } catch (error) {
    yield put(deleteComplaintError(error));
  }
}

function* deleteComplaintDocumentAsync(action: any) {
  try {
    const response: Promise<any> = yield call(API.deleteComplaintDocumentAPI,action.payload.docId);
    yield put(getComplaintDocumentLoading(action.payload.id));
    yield put(deleteComplaintDocumentSuccess(response));
  } catch (error) {
    yield put(deleteComplaintDocumentError(error));
  }
}

function* getComplaintDropdownAsync(action: any) {
  try {
    const response: Promise<any> = yield call(API.getComplaintDropdownForJobsheet,action.payload);
    yield put(getComplaintDropdownSuccess(response));
  } catch (error) {
    yield put(getComplaintDropdownError(error));
  }
}

function* getPrefixDropdownAsync(action: any) {
  try {
    const response: Promise<any> = yield call(API.getPrefixComplaintDropdown);
    yield put(getPrefixDropdownSuccess(response));
  } catch (error) {
    yield put(getPrefixDropdownError(error));
  }
}

function* getComplaintDocumentAsync(action: any): Generator {
  try {
    const response: any = yield call(API.getComplaintDocumentsApi, action.payload);

    // Use Promise.all to fetch all links in parallel
    const links: any = yield call(
      [Promise, Promise.all],
      response.data.map((doc: any) => 
        API.getComplaintDocumentsLinkApi(doc.id)
      )
    );

    // Merge links back into docs
    const documentsWithLinks = response.data.map((doc: any, index: number) => ({
      ...doc,
      fileLink: links[index]?.data || null,
    }));

    yield put(getComplaintDocumentSuccess(documentsWithLinks));
  } catch (error) {
    yield put(getComplaintDocumentError(error));
  }
}


function* getAllComplaintAsync(action: any) {
  try {
    const response: Promise<any> = yield call(API.getallComplaintDropdown);
    yield put(getAllComplaintDropdownSuccess(response));
  } catch (error) {
    yield put(getAllComplaintDropdownError(error));
  }
}

function* complaintSaga(): Generator {
  yield takeLatest(ComplaintTypes.GET_COMPLAINT_LOADING, fetchComplaints);
  yield takeLatest(ComplaintTypes.GET_COMPLAINT_BY_ID_LOADING, fetchComplaintById);
  yield takeLatest(ComplaintTypes.CREATE_COMPLAINT_LOADING, createComplaintFormAsync);
  yield takeLatest(ComplaintTypes.DELETE_COMPLAINT_LOADING, deleteComplaintAsync);
  yield takeLatest(ComplaintTypes.GET_COMPLAINT_DROPDOWN_LOADING, getComplaintDropdownAsync);
  yield takeLatest(ComplaintTypes.GET_PREFIX_DROPDOWN_LOADING, getPrefixDropdownAsync);
  yield takeLatest(ComplaintTypes.GET_COMPLAINT_FILES_LOADING, getComplaintDocumentAsync);
  yield takeLatest(ComplaintTypes.DELETE_COMPLAINT_FILES_LOADING, deleteComplaintDocumentAsync);
  yield takeLatest(ComplaintTypes.GET_ALL_COMPLAINT_DROPDOWN_LOADING, getAllComplaintAsync);
}

export default complaintSaga;